import { MappedGuest } from '../../types';

export const displayedGuests = (
  availableGuests: MappedGuest[],
  isGenderSpecific?: string | boolean
): MappedGuest[] =>
  availableGuests.filter((guest) => {
    if (isGenderSpecific === 'M') {
      return guest.gender === 'male';
    }
    if (isGenderSpecific === 'F') {
      return guest.gender === 'female';
    }
    return true;
  });
